import { API_CONFIG, joinApiUrl } from "../../../config/api.config";

const getTopicsCatalogEndpoint = () => {
  if (!API_CONFIG.QUIZ_URL) {
    throw new Error("REACT_APP_QUIZ_API_URL no esta configurado");
  }
  return joinApiUrl(API_CONFIG.QUIZ_URL, "/api/topics?all=true");
};

export const getTriviaMarketplacePacks = async ({ headers } = {}) => {
  const response = await fetch(getTopicsCatalogEndpoint(), {
    method: "GET",
    headers,
  });

  if (!response.ok) {
    const message = await response.text();
    throw new Error(message || `Error ${response.status}`);
  }

  const data = await response.json();
  return Array.isArray(data?.topics) ? data.topics : [];
};
